import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AddEntityButton from "../../../components/AddEntityButton";
import CategoryFormModal from "./CategoryFormModal";

const AddCategory = ({
  reloadCallback,
  onSuccess,
  iconOnly = true,
  buttonProps = {},
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const handleSuccess = (response, values) => {
    reloadCallback?.(response, values);
    onSuccess?.(response, values);
  };

  return (
    <>
      <AddEntityButton
        iconOnly={iconOnly}
        buttonProps={{
          ...buttonProps,
          onClick: () => setModalOpen(true),
        }}
      >
        + {t("category_add")}
      </AddEntityButton>

      <CategoryFormModal
        open={modalOpen}
        mode="add"
        onClose={() => setModalOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default AddCategory;
